import { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export const useCaptcha = () => {
    const [loadingCaptcha, setLoadingCaptcha] = useState(true);
    const [countdown, setCountdown] = useState(0); // Время в секундах
    const [captchaUrl, setCaptchaUrl] = useState(null);
    
    // Рефы нужны, чтобы состояние было актуальным внутри таймеров и асинхронных функций
    const timerRef = useRef(null);
    const isFetchingRef = useRef(false); // Защита от двойного клика

    const fetchCaptcha = useCallback(async (isAutoRefresh = false) => {
        // Если уже идет загрузка, прерываем выполнение (защита от спама кнопкой)
        if (isFetchingRef.current) return;

        isFetchingRef.current = true;
        setLoadingCaptcha(true);

        // Очищаем старый таймер и URL
        if (timerRef.current) clearInterval(timerRef.current);
        if (captchaUrl) {
            URL.revokeObjectURL(captchaUrl);
        }

        try {
            // Запрос к API
            const response = await axios.get(`/api/captcha/?_=${new Date().getTime()}`, {
                responseType: 'blob'
            });

            const newUrl = URL.createObjectURL(response.data);
            setCaptchaUrl(newUrl);
            
            // Устанавливаем время жизни (300 секунд = 5 минут)
            setCountdown(300);

            // Запускаем таймер
            timerRef.current = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        // Время истекло
                        clearInterval(timerRef.current);
                        
                        // Если это был авто-рефреш, просто грузим новую без уведомления
                        // Или можно показать уведомление
                        if (!isAutoRefresh) {
                            // toast.info("Срок действия капчи истек, обновляем...");
                        }
                        
                        // Сбрасываем флаг загрузки, чтобы разрешить новый запрос из интервала
                        isFetchingRef.current = false; 
                        fetchCaptcha(true); // Автоматическая перезагрузка
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

        } catch (error) {
            console.error("Captcha error:", error);
            if (!isAutoRefresh) {
                toast.error("Не удалось загрузить картинку.");
            }
        } finally {
            setLoadingCaptcha(false);
            isFetchingRef.current = false;
        }
    }, [captchaUrl]); // captchaUrl в зависимостях, чтобы очистить старый

    // Начальная загрузка при монтировании
    useEffect(() => {
        fetchCaptcha(false);
        
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
            if (captchaUrl) URL.revokeObjectURL(captchaUrl);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { 
        loadingCaptcha, 
        captchaUrl, 
        fetchCaptcha, 
        countdown 
    };
};